import React, { useState } from 'react';
import { useLocalStorage } from 'react-use';
import styled from 'styled-components';
import { Colors } from '.';
import { CloseButton } from '../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../Legacy';
import { Position } from './Position';

const Frame = styled.div<{ variant: string }>`
    position: relative;
    padding: 1rem 2.5rem 1rem 1.5rem; 
    margin-bottom: 1rem;
    font-weight: 450;
    font-size: 1.125rem;
    border-radius: .5rem; 

    background: ${p => p.variant === 'primary' ? Colors.mystery : Colors.hover};    
    &, & * {
        color: ${p => p.variant === 'primary' ? 'white' : Colors.text};    
    }
`;

export const InlineHelp: LFC<{ name?: string, variant?: 'primary' | 'secondary' }> = ({ name, variant, children }) => {
    const [dismissed, setDismissed] = !!name ? useLocalStorage(`deqo/help/${name}`, false) : useState(false);

    return !dismissed && <Frame variant={variant ?? 'primary'}>
        {children}
        {name && <Position at="topRight" inset="1.3">
            <CloseButton onClick={() => setDismissed(true)} />
        </Position>}
    </Frame>;
};
